import { render, staticRenderFns } from "./FaturaFilterBar.vue?vue&type=template&id=5707b7f4"
import script from "./FaturaFilterBar.vue?vue&type=script&lang=js"
export * from "./FaturaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports